import { useEffect } from "react";
import { useLocation } from "@/compat/router-compat";
import { siteOrigin } from "@/engine/support/siteHost";

function setLinkHref(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setMetaContent(property: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Keeps canonical and og:url self-referencing per route: the static index.html can
 * only carry the homepage URL, so sub-routes would otherwise claim to be the root.
 */
export function RouteMetaUrls() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const canonicalPath =
      pathname === "/" ? "/" : pathname.replace(/\/+$/, "") || "/";
    const url = `${siteOrigin(window.location.hostname)}${canonicalPath}${search}`;
    setLinkHref("canonical", url);
    setMetaContent("og:url", url);
  }, [pathname, search]);

  return null;
}

export default RouteMetaUrls;
